<script>
	import { logout, validateUser } from '$lib/stores/user/action';
	import { goto } from '$app/navigation';
	import { user } from '$lib/stores/user/store';
	import { PAGES } from '$lib/utils/constants';
	import { onMount } from 'svelte';
	import { app } from '$lib/stores/app/store';
	export let content = {
		loginBtnTxt: '',
		logoutBtnTxt: '',
		dataTrackId: '',
		btnClass: ''
	};

	$: btnText = $user.tokenValid ? content.logoutBtnTxt : content.loginBtnTxt;

	async function handleClick() {
		if ($user.tokenValid) {
			await logout($app);
		} else {
			goto(PAGES.INTERNAL.LOGIN);
		}
	}
</script>

<button
	data-track-id={content.dataTrackId}
	class={content.btnClass ? content.btnClass : 'btn-secondary-blue'}
	on:click|preventDefault={() => handleClick()}
>
	{btnText}
</button>
